export enum ScreenStatus {
    'INITIAL_SCAN' = 'INITIAL_SCAN',
    'LOADING_FETCHING_DATA' = 'LOADING_FETCHING_DATA',
    'RESPONSE_DATA_SUCCESS' = 'RESPONSE_DATA_SUCCESS',
    'RESPONSE_DATA_FAIL' = 'RESPONSE_DATA_FAIL',
}
